import {
    giphyBlack,
    giphyBlue,
    giphyDarkestGrey,
    giphyGreen,
    giphyIndigo,
    giphyPink,
    giphyPurple,
    giphyRed,
} from '@giphy/js-brand'

enum CreationToolGradient {
    IndigoPurple = 'CT_GRADIENT_INDIGO_PURPLE',
    IndigoBlue = 'CT_GRADIENT_INDIGO_BLUE',
    PinkIndigo = 'CT_GRADIENT_PINK_INDIGO',
    BlueGreen = 'CT_GRADIENT_BLUE_GREEN',
    PurpleRed = 'CT_GRADIENT_PURPLE_RED',
    BlackGrey = 'CT_GRADIENT_BLACK_GREY',
}

namespace CreationToolGradient {
    /**
     * Returns the two colors for a gradient.
     */
    export function colors(gradient: CreationToolGradient): string[] {
        switch (gradient) {
            case CreationToolGradient.IndigoPurple:
                return [giphyIndigo, giphyPurple]
            case CreationToolGradient.IndigoBlue:
                return [giphyIndigo, giphyBlue]
            case CreationToolGradient.PinkIndigo:
                return [giphyPink, giphyIndigo]
            case CreationToolGradient.BlueGreen:
                return [giphyBlue, giphyGreen]
            case CreationToolGradient.PurpleRed:
                return [giphyPurple, giphyRed]
            case CreationToolGradient.BlackGrey:
                return [giphyBlack, giphyDarkestGrey]
        }
    }
}

export default CreationToolGradient
